import rootSlice from './slice';

const discoverPeopleReducer = rootSlice.reducer;

export default discoverPeopleReducer;
